module.exports = __webpack_public_path__ + "img/antrian.3d2b11ef.jpg";